var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOpenAmLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 84,
    viewBox: "0 0 71 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8547 21.2264C17.4294 22.5169 23.5501 56.9297 35.7915 61.6615C48.0329 66.3933 40.28 19.936 28.8547 21.2264Z",
    fill: "#33AADD",
    stroke: "#33AADD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1978 19.8268C28.9182 27.3534 24.8007 50.6136 38.8719 61.5201L44.0204 62.4943L46.1575 41.1605L34.8892 16.9044L31.1978 19.8268ZM16.9741 6.22818L40.1348 2C64.2529 4.52667 70.2704 26.0548 69.0827 41.8424C67.6872 60.3914 63.3281 64.2331 59.66 68.6314L39.0116 80.5951L22.8437 75.4504L9.63262 60.6434L5.06702 40.5761L9.63262 16.7096L16.9741 6.22818Z",
    fill: "#33AADD",
    stroke: "#33AADD",
    strokeWidth: 2.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5972 73.5901C38.1765 74.5405 40.6118 56.8959 40.5834 47.2426C40.5324 29.9615 33.1698 15.688 20.7666 15.6601C11.8043 15.64 9.60019 28.4393 9.30151 37.8156C8.82059 52.9134 13.7438 72.1166 28.5972 73.5901ZM16.9741 6.22813C35.6619 4.21897 50.3507 24.7101 50.1508 48.3152C50.04 61.4008 47.4273 81.1512 34.0776 81.9642C17.9248 82.9479 4.50104 63.442 2.44644 45.0433C0.875503 30.9757 2.93879 7.7371 16.9741 6.22813Z",
    fill: "white",
    stroke: "#33AADD",
    strokeWidth: 2.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2295 39.4145C51.0762 50.0306 50.0453 60.0637 46.9373 67.6914C43.8232 75.3344 38.6984 80.4186 32.4197 81.5108C26.141 82.603 19.6004 79.548 14.0882 73.4056C8.5871 67.2755 4.22874 58.1799 2.38204 47.5637C0.527031 36.8998 0.913822 27.0887 3.37412 19.7032C5.83209 12.3246 10.2932 7.51048 16.5464 6.42274C22.8683 5.32303 30.086 8.1866 36.2524 14.1039C42.4003 20.0034 47.3911 28.8463 49.2295 39.4145Z",
    fill: "white",
    stroke: "#33AADD",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7205 42.8675C39.4162 49.6968 38.3969 56.0232 36.2122 60.7264C34.0223 65.4409 30.7101 68.4392 26.8516 68.8323C22.9931 69.2254 19.1443 66.9566 16.0487 62.7807C12.9604 58.6147 10.6862 52.6238 9.99043 45.7945C9.29233 38.9423 9.91225 32.7275 11.696 28.1448C13.4803 23.5608 16.3842 20.6986 20.229 20.3069C24.1103 19.9114 28.3716 22.0873 31.8699 26.1484C35.3578 30.1976 38.027 36.0609 38.7205 42.8675Z",
    fill: "#33AADD",
    stroke: "#33AADD"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenAmLogo);
export default __webpack_public_path__ + "static/media/OpenAM_logo.76a075c28fdeec6db393c77d46596286.svg";
export { ForwardRef as ReactComponent };